// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.landlord.v1.property.SatelliteWebLandlordPropertyHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
  SatelliteWebLandlordPropertyGetAddressDetailsResponseDto,
  SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
  SatelliteWebLandlordPropertyGetListingPerformanceResponseDto,
  SatelliteWebLandlordPropertySearchRequestDto,
  SatelliteWebLandlordPropertySearchResponseDto,
} from '../..';

export const SatelliteWebLandlordPropertyHandler_getAddressDetails_Path =
  '/api/web/landlord/v1/property/getAddressDetails';

export const SatelliteWebLandlordPropertyHandler_getAddressDetails = (
  postData: SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordPropertyGetAddressDetailsRequestDto,
    SatelliteWebLandlordPropertyGetAddressDetailsResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordPropertyHandler_getAddressDetails_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordPropertyHandler_getListingPerformance_Path =
  '/api/web/landlord/v1/property/getListingPerformance';

export const SatelliteWebLandlordPropertyHandler_getListingPerformance = (
  postData: SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordPropertyGetListingPerformanceRequestDto,
    SatelliteWebLandlordPropertyGetListingPerformanceResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordPropertyHandler_getListingPerformance_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebLandlordPropertyHandler_search_Path = '/api/web/landlord/v1/property/search';

export const SatelliteWebLandlordPropertyHandler_search = (
  postData: SatelliteWebLandlordPropertySearchRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebLandlordPropertySearchRequestDto,
    SatelliteWebLandlordPropertySearchResponseDto
  >(
    {
      endpoint: SatelliteWebLandlordPropertyHandler_search_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
